import { ChangeEvent, FC, useState } from 'react'
import classNames from 'classnames'

import { IconButton } from '@/compositions'
import { validatePincodeRegistrationData } from '@/compositions/RegistrationFlow/helpers/validateFormData'
import { UserFormData } from '@/entities/User/User'
import { isObjEmpty } from '@/helpers/tools'
import { trans } from '@/helpers/trans'

import './PincodeRegistration.scss'


interface PincodeRegistrationProps {
    values: UserFormData
    onChange: (formData: Partial<UserFormData>) => void
    onNextStep: () => void
    onPreviousStep: () => void
    className?: string
    inputClassName?: string
}

const pincodeLength = 4

export const PincodeRegistration: FC<PincodeRegistrationProps> = ({
    values,
    onChange,
    onNextStep,
    onPreviousStep,
    className = '',
    inputClassName = '',
}) => {
    const [submitted, setSubmitted] = useState(false)
    const [isDisabled, setIsDisabled] = useState(true)
    const validationErrors = validatePincodeRegistrationData(values, submitted)

    const onNextStepClick = () => {
        setSubmitted(true)
        if (isObjEmpty(validatePincodeRegistrationData(values, true))) {
            onNextStep()
        }
    }

    const onChangePincode = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length > 0) {
            setIsDisabled(false)
        }

        onChange({ pincode: e.target.value })
    }

    const onChangePincodeRepeat = (e: ChangeEvent<HTMLInputElement>) => {
        onChange({ pincodeRepeat: e.target.value })
    }

    return (
        <div className={`pincode-registration ${className}`}>
            <h4 className="pincode-registration__title">{trans('pages.registration.pincodeTitle')}</h4>
            <div className="pincode-registration__modal-body">
                <p>
                    {trans('pages.registration.pincodeIntro', { employeeNumber: values.employeeNumber })}
                </p>
                <div className="pincode-registration__row">
                    <div className="pincode-registration__col">
                        <div className="pincode-registration__row">
                            <div className="pincode-registration__col">
                                <div className="form-group">
                                    <label>{trans('common.pincode')}</label>
                                    <input
                                        className={classNames('form-control', inputClassName, { 'is-invalid': !! validationErrors.pincode })}
                                        type="password"
                                        name="pincode"
                                        id="pincode"
                                        maxLength={pincodeLength}
                                        pattern="[0-9]*"
                                        placeholder={trans('pages.registration.enterPincode')}
                                        defaultValue={values.pincode}
                                        onChange={onChangePincode}
                                    />
                                    <div className="invalid-feedback">
                                        { validationErrors.pincode }
                                    </div>
                                </div>
                            </div>
                            <div className="pincode-registration__col">
                                <div className="form-group">
                                    <label>{`${trans('common.confirm')} ${trans('common.pincode')}`}</label>
                                    <input
                                        className={classNames('form-control', inputClassName, { 'is-invalid': !! validationErrors.pincodeRepeat })}
                                        type="password"
                                        name="pincodeRepeat"
                                        id="pincode-repeat"
                                        maxLength={pincodeLength}
                                        pattern="[0-9]*"
                                        placeholder={trans('pages.registration.repeatPincode')}
                                        defaultValue={values.pincodeRepeat}
                                        onChange={onChangePincodeRepeat}
                                    />
                                    <div className="invalid-feedback">
                                        { validationErrors.pincodeRepeat }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pincode-registration__row">
                    <div className="pincode-registration__button-container">
                        <IconButton
                            icon="chevron-left"
                            text={trans('common.back')}
                            onClick={onPreviousStep}
                            className="pincode-registration__back-button"
                        />
                        <IconButton
                            disabled={isDisabled}
                            icon="check"
                            text={trans('common.save')}
                            onClick={onNextStepClick}
                            className="pincode-registration__save-button"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
